<template>
    <div id="app">
        
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">

                <br/>
                <vs-card class="cardx" >

                    <div slot="header">
                        <div index="0" style="float: right;">
                            <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                                <span class="cursor-pointer flex i18n-locale"><img class="h-5 w-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2">{{getCurrentLocaleData.lang}}</span></span>
                                <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
                                    <vs-dropdown-item @click="updateLocale('en')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t("tr_to_en")}}</vs-dropdown-item>
                                    <vs-dropdown-item @click="updateLocale('fr')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t("tr_to_fr")}}</vs-dropdown-item>
                                    <vs-dropdown-item @click="updateLocale('de')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t("tr_to_de")}}</vs-dropdown-item>
                                    <vs-dropdown-item @click="updateLocale('pt')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t("tr_to_pt")}}</vs-dropdown-item>
                                    <vs-dropdown-item @click="updateLocale('es')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/es.png" alt="pt" /> &nbsp;{{ $t("tr_to_es")}}</vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                        
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-sm="1" >                                
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="4" >
                                <img :src="require('@/assets/images/pages/logo_questionario.png')" alt="Logo-Satsanga">
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6"  >
                                <vs-row vs-type="flex" vs-justify="center">
                                    <h2 style="text-align: center;">{{$t('survey_name')}}</h2> 
                                </vs-row>                               
                            </vs-col>
                        </vs-row>
                        <vs-row vs-justify="center" style="padding-top: 15px">
                            <h3> {{ $t("survey_message") }}</h3>
                        </vs-row>
                    </div>

                    <div>                                                
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="11" vs-sm="11" vs-xs="11" >
                                <table class="w-full">
                                    <thead>
                                        <tr>
                                        <th></th>
                                        <th>{{ $t("survey_table_option1") }}</th>
                                        <th>{{ $t("survey_table_option2") }}</th>
                                        <th>{{ $t("survey_table_option3") }}</th>
                                        <th>{{ $t("survey_table_option4") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="$route.name === 'survey2'">
                                        <tr :class="item.class_name" :key="index" v-for="(item,index) in surveyItemsGroup">
                                            <td> {{ $t(item.tag) }} </td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="rowselected.questions[item.survey_item_group_id]"  
                                                    :vs-value="JSON.stringify({'item_id' : item.survey_item_group_id,'item_group' : item.survey_group_id ,'val' : 4})">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="rowselected.questions[item.survey_item_group_id]"  
                                                    :vs-value="JSON.stringify({'item_id' : item.survey_item_group_id,'item_group' : item.survey_group_id ,'val' : 3})">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="rowselected.questions[item.survey_item_group_id]"  
                                                    :vs-value="JSON.stringify({'item_id' : item.survey_item_group_id,'item_group' : item.survey_group_id ,'val' : 2})">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="rowselected.questions[item.survey_item_group_id]"  
                                                    :vs-value="JSON.stringify({'item_id' : item.survey_item_group_id,'item_group' : item.survey_group_id ,'val' : 1})">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>                                 
                                        </tr>
                                    </tbody>
                                
                                    <tbody v-else>
                                        <tr :class="item.class_name" :key="index" v-for="(item,index) in surveyItemsGroup.form">
                                            <td> {{ $t(item.tag) }} </td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="surveyItemsGroup.responses[index].answer"  
                                                    :vs-value="item.survey_item_group_id+ '_' +'4'">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="surveyItemsGroup.responses[index].answer"  
                                                    :vs-value="item.survey_item_group_id+ '_' +'3'">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="surveyItemsGroup.responses[index].answer"  
                                                    :vs-value="item.survey_item_group_id+ '_' +'2'">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td>
                                            <td v-if="item.class_name == 'question' ">
                                                <vs-radio v-model="surveyItemsGroup.responses[index].answer"  
                                                    :vs-value="item.survey_item_group_id+ '_' +'1'">
                                                </vs-radio>
                                            </td>
                                            <td v-else></td> 
                                        </tr>
                                    </tbody>
                                </table>
                            </vs-col>
                        </vs-row>

                        <br/><br/>
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="left" vs-lg="4" vs-sm="4" vs-xs="3" >
                                <h6>{{ $t("survey_hotel") }}: </h6>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="6" >
                                <h6 class="small">{{rowselected.hotel}}</h6>
                            </vs-col>                            
                        </vs-row>
                    

                        <br/>
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="left" vs-lg="4" vs-sm="4" vs-xs="3" >
                                <h6>{{ $t("survey_treatment") }}: </h6>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="6" >
                                <h6 class="small">{{rowselected.treatment}}</h6>
                            </vs-col>                            
                        </vs-row>

                        <br/>
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="left" vs-lg="4" vs-sm="4" vs-xs="3" >
                                <h6>Terapeuta:</h6>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="6" >
                                <h6 class="small">{{rowselected.therapist_name}}</h6>
                            </vs-col>                            
                        </vs-row>
                    
                        <br/>
                        <vs-row vs-w="12" vs-justify="center">
                            <vs-col v-if="displayView !== true" vs-type="flex" vs-align="center" vs-justify="center" vs-lg="10" vs-sm="8" vs-xs="10" >
                                    <vs-textarea class="w-3/4" v-model="rowselected.comments" :label="$t('survey_comments')" height="100" />
                            </vs-col>
                            <vs-col v-else vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="8" vs-xs="10" >
                                    <vs-textarea class="teste" v-model="rowselected.comments" :label="$t('survey_comments')" height="100" disabled/>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="7" vs-xs="12" >
                                <h5>{{ $t("survey_thanks") }}</h5>
                            </vs-col>
                        </vs-row>

                        <br/>
                        <vs-row vs-justify="center">
                            <vs-button v-if="displayView !== true" color="primary" @click="addSurvey" type="filled">{{ $t("survey_button") }}</vs-button>                            
                        </vs-row>
                    </div>

                </vs-card>
            </vs-col>
        </vs-row>
        <br/><br/><br/>

    </div>
</template>

<script>

import Vue from 'vue'

import themeConfig from '@/../themeConfig.js';

import axios from 'axios';   

import VueI18n from 'vue-i18n'

Vue.use(VueI18n);


export default {
    data(){
        return {

            surveyItemsGroup: [],
            rowselected: {
                questions: {},
            },
            displayView : false,
            lang: null,
        }
    },

    components: {
    },

    methods: {
        getCurrentLocaleData() {
            const locale = this.$i18n.locale;
            if (locale == "en") return { flag: "en", lang: this.$i18n.messages['en'].tr_to_en }
            else if (locale == "pt") return { flag: "pt", lang: this.$i18n.messages['pt'].tr_to_pt }
            else if (locale == "fr") return { flag: "fr", lang: this.$i18n.messages['fr'].tr_to_fr }
            else if (locale == "de") return { flag: "de", lang: this.$i18n.messages['de'].tr_to_de }
            else if (locale == "es") return { flag: "es", lang: this.$i18n.messages['es'].tr_to_es }
        },
        loadSurveyItemsGroups(){
            let that = this;

            this.$vs.loading();

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/survey/items/group?token='+process.env.VUE_APP_TOKEN,
            })
            .then(function (res) { 
                if(res.status == 200)
                { 
                that.surveyItemsGroup = res.data;
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function(){
                that.$vs.loading.close();
            }); 
        }, 

        loadSurveyInfo(id) {
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/survey/info?token='+process.env.VUE_APP_TOKEN,
                params: {
                    schedule_event_id: id,
              }
            })
            .then(function (res) { 
                if(res.status == 200){
                    that.rowselected.hotel = res.data.hotel;
                    that.rowselected.treatment = res.data.treatment;
                    that.rowselected.therapist_name = res.data.therapist;
                    that.rowselected.schedule_event_id = id;

                    that.loadSurveyItemsGroups();
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            }) 
        },

        loadSurveyAwswers(data) {
            let that = this;

            this.$vs.loading();
            
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/survey/answers?token='+process.env.VUE_APP_TOKEN,
                params : {
                    survey_id : data.survey_id,
                    schedule_id : data.schedule_id,
                }
            })
            .then(function (res) 
            { 
                if(res.status == 200)
                { 
                    that.surveyItemsGroup = res.data;
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function(){
                that.$vs.loading.close(); 
            }); 
        },

        addSurvey(){
            let that = this; 

            let tempLocale = this.$i18n.locale;

            let temp = this.surveyItemsGroup.filter(item => item.class_name === "question").length;

            if(Object.keys(this.rowselected.questions).length !== temp) 
            {
                this.$vs.notify({title:'',text: this.$i18n.messages[tempLocale].survey_bad ,color:'Red', position:'top-center', 
                    iconPack: 'feather',icon:'icon-alert-circle',time:4000,});

            }else
            {     
                this.$vs.loading();
                axios({
                    method: 'post',
                    ContentType: 'application/json',
                    url: themeConfig.apiurl + '/spa/new/survey?token='+process.env.VUE_APP_TOKEN,
                    data: {
                        survey: this.rowselected
                    }
                })
                .then(function (response) 
                {        
                    if(response.status == 200)
                    {  
                        that.displayView = true;

                        if(response.data === 'Error1')
                        {
                            that.$vs.notify({title:'',text: that.$i18n.messages[tempLocale].survey_bad_message ,color:'Red',
                                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});

                        }else
                        {              
                            that.$vs.notify({title:'',text: that.$i18n.messages[tempLocale].survey_good ,color:'#63C0BB',position:'top-center',
                                iconPack: 'feather',icon:'icon-check',time:4000,});
                        }   
                    }  
                    
                    that.$vs.loading.close();   
                })
                .catch(function (error) {
                    if (error.response) {
                        let  fields = [];
                        let  obj    = error.response.data.fields;

                        for (let  prop in obj) {
                            fields.push(obj[prop]);
                        }

                        that.notify(fields.join("<br>"), 'red', 10);
                    } else {
                        that.notify("An unknown error has occured", 'red', 10);
                    }
                    
                    that.$vs.loading.close();
                });
            } 
        },

        displaySurveyAnswers(data){
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/survey/info?token='+process.env.VUE_APP_TOKEN,
                params: {
                    schedule_event_id: data.schedule_id,
              }
            })
            .then(function (res){ 
                if(res.status == 200){
                    that.rowselected.hotel = res.data.hotel;
                    that.rowselected.treatment = res.data.treatment;
                    that.rowselected.therapist_name = res.data.therapist;
                    that.rowselected.schedule_event_id = data.schedule_id;

                    that.rowselected.comments = res.data.comments;

                    that.loadSurveyAwswers(data);

                    that.displayView = true;
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            });
        },
    },
    created(){
        if(typeof this.$route.params.lang !== 'undefined'){
            this.lang = this.$route.params.lang;
        }
    },
    mounted: function() {
        if(this.$route.name === 'survey3'){
            let data = {
                'schedule_id' : this.$route.params.schedule_id,
                'survey_id' : this.$route.params.survey_id,
            }

            this.displaySurveyAnswers(data);

        }else if(this.$route.name === 'survey2'){
            let data = JSON.parse(this.$route.params.data);
            
            this.loadSurveyInfo(data);
        }
    },
    watch: {

        lang(new_val, old_val) {
            this.updateLocale(new_val);
        },

    }


}
</script>

<style>

table { 
    border-collapse: collapse;
    border-bottom: 1px solid black;
}

table thead tr {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

table thead tr th:nth-child(2) {
  border-left: 1px solid black;
}

table th, table td:not(:nth-child(1)) {
  text-align: center;
  padding: 5px 10px;
  vertical-align: middle;
}

td {
  padding: 5px 10px;
  font-size: 14px;
}

tr.new_group {
  border-top: 1px solid black;
  padding-top: 10px;
  font-weight: bold;
  font-size: 14px;
}

td:nth-child(1) {
  border-right: 1px solid black;
}

</style>

<style >

.vs-card--header{
    -webkit-box-shadow: none;
    box-shadow: none;
}

</style>

<style>

@media only screen and (max-width: 600px) {

  img {
    width: 100%;
    max-width: 100px;
    height: auto; 
  }
  
  h2 {
    font-size: 10px;    
    padding-top: 15px;
  }

  h3 {
    font-size: 10px;
    text-align: center;
  }
  
  h5 {
    font-size: 12px;
    text-align: center;
  }

  h6 {
    font-size: 8px;
  }

  h6.small {
    font-size: 7px;
  }

  table, th {
    font-size: 8px;
    padding: 5px;
  }

  table td {
    font-size: 9px;
    padding : 5px 7px;
  }

  table th, table td:not(:nth-child(1)) {
    padding: 5px;
  }

  .vs-radio--borde, .vs-radio--circle {
    width: 80%;
    height: 80%;
  }

  .con-vs-radio {
    display: inline-block;
  }

  .vs-card--content{
    padding-bottom: 10px !important;    
  }

  .vs-row {
      flex-flow: inherit;
  }

  .vs-col {
    padding: 0;
  }

  .vs-radio--label {
    margin-left: 0px;
  }

  .vs-con-textarea h4{
      font-size: 0.4rem;
  }

  .vs-textarea {
    font-size: 0.6rem;
    height: 70px  !important;
  }
  
} 
</style>
